import { forwardRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TemplateRegion } from '@dreamtree-org/landing-kit';
import '@dreamtree-org/landing-kit/styles.css';
import { useStorefront } from '../StorefrontContext';
import { withoutPlaceholderBlocks } from '../lib/placeholders';

/** landing-kit links go through the router (`to`), like every other storefront link. */
export const RouterLink = forwardRef(({ to, href, ...rest }, ref) => <Link ref={ref} to={to || href} {...rest} />);
RouterLink.displayName = 'RouterLink';

/**
 * A template page's blocks in the owner's order (D64): commerce slots from
 * `slots`, content sections themed like the landing page. A text block still
 * holding landing-kit's sample copy is left out (MERCH-55, lib/placeholders).
 */
export default function Region({ blocks, slots, className = '' }) {
  const sf = useStorefront();
  const theme = sf.appearance ? { ...sf.appearance.theme, mode: 'auto' } : undefined;
  return (
    <TemplateRegion
      blocks={withoutPlaceholderBlocks(blocks)}
      slots={slots}
      theme={theme}
      resolveMedia={(ref) => sf.mediaUrl(ref)}
      linkComponent={RouterLink}
      storeName={sf.seller.name}
      className={className}
    />
  );
}

/** True at `lg` and wider (filters in a side sheet rather than a bottom sheet). */
export function useWide(query = '(min-width: 1024px)') {
  const get = () => {
    try {
      return window.matchMedia(query).matches;
    } catch {
      return false;
    }
  };
  const [wide, setWide] = useState(get);
  useEffect(() => {
    let mq;
    try {
      mq = window.matchMedia(query);
    } catch {
      return undefined;
    }
    const on = () => setWide(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => (mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on));
  }, [query]);
  return wide;
}
